import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbItemClickEvent, BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';

import { ThemeService } from '@offconon/shared/ui/theme-switch';

@Component({
  selector: 'offconon-admin-module-header',
  imports: [
    CommonModule,
    BreadcrumbModule,
    ButtonModule,
    TranslateModule,
    RouterModule,
    ButtonModule,
  ],
  templateUrl: './admin-module-header.component.html',
  styles: ``,
})
export class AdminModuleHeaderComponent implements OnInit, OnChanges {
  @Input() moduleData: {
    menuItems?: MenuItem[];
    title: string;
    subtitle: string;
    backgroundImage: string;
  };

  private router = inject(Router);
  private themeService = inject(ThemeService);

  mobilView = toSignal(this.themeService.mobileView);

  background_image: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['moduleData']) {
      this.background_image = this.moduleData?.backgroundImage
        ? this.moduleData?.backgroundImage
        : null;
    }
  }

  ngOnInit() {
    this.background_image = this.moduleData?.backgroundImage
      ? this.moduleData?.backgroundImage
      : null;
  }

  navigateItem(event: BreadcrumbItemClickEvent) {
    this.router.navigate([event.item['route']]);
  }
}
